<template>

    <section>
        <!--:::::::::::::::::::::::::::::::::::::::::::::::
            ModalValidation
        :::::::::::::::::::::::::::::::::::::::::::::::::-->
        <div class="modal_container alert ModalValidation" :class="classObject">
            <div class="modal_wrap">

                <!-- Title -->
                <div v-if="title" class="modal_title">
                    <h3><span>{{title}}</span></h3>
                </div>

                <!-- Body -->
                <div class="modal_body">
                    <div v-if="message" class="inner">
                        <p>{{message}}</p>
                    </div>
                </div>

                <!--btn-link-wrap-->
                <div class="btn_link-wrap">

                    <button class="btn_link md_icon-text _white" @click="coolClose">
                        <div class="inner">
                            <span><div class="icon"><SvgIconCheck /></div>OK</span>
                        </div>
                    </button>

                </div><!--/.btn-link-wrap-->

            </div>
            <div class="modal_close-ovl js-modal-close"></div>
        </div>
    </section>

</template>


<script>

    //Svg
    import SvgIconCheck from '@/components/EndUser/svg/SvgIconCheck'
    import SvgIconCancel from '@/components/EndUser/svg/SvgIconCancel'
    import SvgIconDelete from '@/components/EndUser/svg/SvgIconDelete'

    export default {
        components: {
            //Svg
            SvgIconCheck,
            SvgIconCancel,
            SvgIconDelete
        },
        props: {
            title: String,
            message: String,
            mode: String
        },
        emits: ['close'],
        mounted() {
            setTimeout(this.coolOpen, 200);    
        },
        computed: {
            classObject() {
                return {
                    '_delete': this.mode === "error"
                }
            }
        },
        methods: {
            coolOpen(){
                $('.modal_container.alert').addClass('_open');
                $('.modal_bg').addClass('_on');
            },
            coolClose(){
                setTimeout(()=> {
                    this.$emit('close');
                }, 200);
                $('.modal_container.alert').removeClass('_open');
                $('.modal_bg').removeClass('_on');
            }
        }
    }
</script>